import { ArrowUpRight, Store, UtensilsCrossed, BadgeCheck } from "lucide-react";

const SITES = [
  { id: "profesionalpos", label: "PROFESIONALPOS", url: "https://profesionalpos.com", host: "profesionalpos.com", icon: Store },
  { id: "profesionalposrestaurante", label: "PROFESIONALPOS RESTAURANTE", url: "https://profesionalposrestaurante.com", host: "profesionalposrestaurante.com", icon: UtensilsCrossed },
];

export function AlreadyBought() {
  return (
    <section id="ya-compraste" className="bg-foreground text-white" data-testid="already-bought-section">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
        <div className="grid gap-10 lg:grid-cols-5 lg:items-center">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-1.5 text-white/80">
              <BadgeCheck className="h-4 w-4 text-primary" /><span className="overline">Clientes</span>
            </span>
            <h2 className="mt-5 font-display text-4xl font-black tracking-tighter md:text-5xl">¿YA COMPRASTE TU LICENCIA?</h2>
            <p className="mt-4 text-white/60">Selecciona tu sistema para descargarlo y activarlo con tu ID de activación.</p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-3">
            {SITES.map((s) => (
              <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`already-bought-${s.id}`}
                className="group flex flex-col justify-between rounded-2xl border border-white/15 bg-white/5 p-7 transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-primary hover:bg-white/10">
                <div className="flex items-start justify-between">
                  <s.icon className="h-8 w-8 text-primary" />
                  <ArrowUpRight className="h-5 w-5 text-white/40 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-white" />
                </div>
                <div className="mt-10">
                  <p className="font-display text-xl font-extrabold tracking-tight">{s.label}</p>
                  <p className="mt-1 text-sm text-white/50">{s.host}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
